import { useCallback } from 'react';
import type { TRunGuaranteesApplicationRequestOptions } from '../types.ts';

type TUseGuaranteesApplicationRequestParams = {
  contragentId: string;
  applicationId: string;
  version: number;
  onError: (error: unknown) => void;
};

export const useGuaranteesApplicationRequest = ({
  contragentId,
  applicationId,
  version,
  onError,
}: TUseGuaranteesApplicationRequestParams) =>
  useCallback(
    async <TResult>({
      skipNewApplication = false,
      request,
    }: TRunGuaranteesApplicationRequestOptions<TResult>): Promise<TResult | null> => {
      if (!contragentId || !applicationId || (skipNewApplication && applicationId === 'new')) {
        return null;
      }

      try {
        return await request({
          contragentId,
          applicationId,
          version,
        });
      } catch (error) {
        onError(error);

        return null;
      }
    },
    [applicationId, contragentId, onError, version]
  );
